import {IDS} from '../audit-action-id.constants';
import {TYPES} from '../audit-action-type.constants';
import * as AuditActions from '../audit.actions';
import * as AuditAddActions from './add.actions';
import * as AccreditationActions from '../../accreditation.actions'
import {formatDate} from '../../../../common/utils/util.date';
import {DATE_FORMAT} from '../../../../common/utils/util.constants';
import pick from 'lodash/pick';
import get from 'lodash/get';
import {TYPES as ACC_TYPES} from "../../accreditation-action-type.constants";
import moment from "moment";
import {GRID_FETCH} from "../../../../common/grid/grid.constants";
import {error} from "../../../../common/utils/util.notifier";
import API from "../../../../common/http/api.fetch";

class AuditAddController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $location,
                $scope,
                $rootScope,
                $filter,
                Notifier,
                DocumentManager,
                AuthService,
                AccountService,
                EmployeeService,
                $timeout) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.user = AuthService.getUser();
        this.AccountService = AccountService;
        this.EmployeeService = EmployeeService;
        this.$timeout = $timeout;
        this.identifier = IDS.accAudit;
        this.selectedFormat = null;
        this.MAX_AUDITORS = 4;
    }

    async $onInit() {
        this.schemeCode = this.$stateParams.itemCode;
        this.unsubscribe = this.$ngRedux.connect(state => {
            const addAudit =    state.accreditation.accAudit.addAudit;
            const details =     state.accreditation.accAudit.details;
            const addAuditRequirementsGrid = state.accreditation.accAudit.addAuditRequirementsGrid;
            const {fiscalYearStart, maxDueDate, minDueDate} = state.accreditation.accAudit.siteLocation;
            const headOfficeFiscalYearStart = state.accreditation.accAudit.headOfficeFiscalYearStart;
            const {siteLocation, headOffice, year} = state.accreditation.accDashboardLocationYear;

            return {
                level1Requirements:   addAudit.level1Requirements,
                level3Requirements:   addAudit.level3Requirements,
                headOffice,     // uuid
                siteLocation,   // uuid
                fiscalYear: year,
                fiscalYearStart: fiscalYearStart || headOfficeFiscalYearStart,
                maxDueDate,//moment(`${year}`).add(fiscalYearStart, 'months').subtract(1,'days').toDate(),
                minDueDate,//new Date();
                sectionsTree:          state.accreditation.simpleSectionsTree,

                requirementId:         details.requirementId,
                requirementParentId:   details.requirementParentId,
                sectionName:           details.sectionName,
                sectionLevel:          details.sectionLevel,

                //review
                name:                   details.name,
                description:            details.description,
                requirementEvidenceDate:details.requirementEvidenceDate,
                requirementAuditDate:   details.requirementAuditDate,

                evidenceOwner:          details.evidenceOwner,
                auditors:               details.auditors,
                auditRequestId:         details.auditRequestId,
                sourceTab:              details.sourceTab,
                selectedAuditor:        details.selectedAuditor,

                //external evidence provider
                evidenceProviderFirstName:  details.evidenceProviderFirstName,
                evidenceProviderLastName:   details.evidenceProviderLastName,
                evidenceProviderEmail:      details.evidenceProviderEmail,

                //external quality manager
                qualityManagerFirstName:    details.qualityManagerFirstName,
                qualityManagerLastName:     details.qualityManagerLastName,
                qualityManagerEmail:        details.qualityManagerEmail,
                activities:                 details.activities,
                assignedRequirements:       addAuditRequirementsGrid.items,
            }
        }, {
            ...AccreditationActions,
            ...AuditActions,
            ...AuditAddActions
        })(this);

        this.paramsSlo = this.$stateParams.slo;
        this.paramsHof = this.$stateParams.hof;
        this.selectCascadeBehaviour = this.paramsSlo ? '' : 'selectDefault'; // if site location is not set, select first head office and site location
        // this.$stateParams.slo = null;
        // this.$stateParams.hof = null;

        const preselectedRequirement = get(this.$ngRedux.getState(), 'accreditation.accAudit.addAudit.preselectedRequirement');
        if(preselectedRequirement) {
            this.preselectedRequirement = preselectedRequirement;
            // reset preselected requirement in redux store
            this.$ngRedux.dispatch({
                type: TYPES.PRESELECT_REQUIREMENT_FOR_NEW_AUDIT,
                requirementId: null,
            });
        }


        this.schemeCode =   this.$stateParams.itemCode;

        this.resetFields();
        this.updateAutocompleteLabel();

        this.unsubscribeLocationChange = this.$scope.$on('LOCATION_SUBJECT_SELECTED', this.onLocationChange.bind(this));
        // this.unsubscribeSelectCascadeLoaded = this.$scope.$on('SELECT_CASCADE_SUBJECTS_LOADED', this.onSelectCascadeLoaded.bind(this));
        this.unsubscribeLocationNotFound = this.$scope.$on('LOCATION_SUBJECT_NOT_FOUND', this.onLocationNotFound.bind(this));

        let siteLocation;
        let headOffice;
        if(this.isSingleSiteUser()) { // no other site can be selected then user's site
            siteLocation = this.user.parents[0].uuid;
        }
        // if coming from schedule by selecting a site and requirement
        else if(this.paramsSlo) {
            siteLocation = this.paramsSlo;
        }
        if(siteLocation) {
            const result = await this.EmployeeService.getEmploymentLocations(siteLocation);
            headOffice = result[0] && result[0].uuid;
            if (headOffice) {
                setTimeout(() => {
                    this.initSelectCascade(headOffice, siteLocation)
                }, 200);
            }
        }
        if(this.$stateParams.due_date) {
            this.$ngRedux.dispatch({
                type: TYPES.SET_AUDIT_DUE_DATE,
                date: new Date(`${this.$stateParams.due_date} 00:00:00`),
            });
        }
    }

    isSingleSiteUser() {
        return this.user.parentCount === 1 && this.user.parents[0].basicType === 'slo';
    }

    initSelectCascade(headOffice, siteLocation) {
        if (this.isSingleSiteUser()) {
            this.$rootScope.$broadcast('FORCE_SELECT_PARENT', 0, siteLocation, null);
        } else {
            this.$rootScope.$broadcast('FORCE_SELECT_PARENT', 0, headOffice, siteLocation);
        }
    }

    async onSelectCascadeLoaded() {
        // const siteLocation = this.siteLocation;
        // if(siteLocation) {
        //     const result = await this.EmployeeService.getEmploymentLocations(siteLocation)
        //     const headOffice = result[0] && result[0].uuid;
        //     if(headOffice) {
        //         setTimeout(()=>{this.initSelectCascade(headOffice, siteLocation)}, 200);
        //     }
        // }
        //
        // if(this.$stateParams.year){
        //     this.$ngRedux.dispatch({
        //         type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
        //         accDashboardLocationYear: {
        //             year: this.$stateParams.year,
        //         }
        //     });
        // }
    }

    async initSectionsInputSelects (siteLocation) {
        const skipEmptyNodes = true;
        await this.fetchFrameworkRequirementsTree(this.schemeCode, siteLocation, this.fiscalYear, skipEmptyNodes);
        // insert requirements to first requirement select box
        this.$ngRedux.dispatch({
            type: TYPES.SELECT_NEW_AUDIT_REQUIREMENT,
            id: this.identifier,
            level:0,
            requirements: this.sectionsTree,
            requirementId: null,
            requirementParentId: null,
        });
        const selectedLevel1Id = get(this.sectionsTree, '[0].id');
        const selectedLevel2Id = get(this.sectionsTree,'[0].children[0].id');
        if(selectedLevel1Id)
            this.onSelectRequirement({item:{value: selectedLevel1Id}});
        if(selectedLevel2Id)
            this.onSelectRequirement({item:{value: selectedLevel2Id}});

        if(this.preselectedRequirement && this.siteLocation){
            this.requirementId = this.preselectedRequirement;
            this.preselectedRequirement = null;
            this.onButtonAssignRequirement()
        }
    }

    onSelectRequirement({item}){
        const requirement = this.findChildSectionById(item.value, this.sectionsTree);
        this.$ngRedux.dispatch({
            type:               TYPES.SELECT_NEW_AUDIT_REQUIREMENT,
            id:                 this.identifier,
            level:              requirement.level,
            requirements:       requirement.children,
            name:               requirement.name,
            requirementId:      requirement.id,
            requirementParentId:requirement.parentId,
        });
    }

    onButtonAssignRequirement = () => {
        //verify limit of 100 requirements is not reached
        if (this.assignedRequirements.length === 100)
            return
        const requirement = this.findChildSectionById(this.requirementId, this.sectionsTree);
        //verify that requirement is not already selected
        if(this.assignedRequirements.find(assigned => assigned.id === this.requirementId)) {
            this.Notifier.error('ACCREDITATION.AUDIT.ADD.SECTION_ALREADY_SELECTED', 6);
            return
        }
        //verify that requirement parent is not already selected
        if(this.assignedRequirements.find(assigned => assigned.id === this.requirementParentId)) {
            this.Notifier.error('ACCREDITATION.AUDIT.ADD.SECTION_PARENT_ALREADY_SELECTED', 6);
            return
        }
        //verify that requirement child is not already selected
        if(this.assignedRequirements.find(assigned => requirement.children.some(child => child.id === assigned.id))) {
            this.Notifier.error('ACCREDITATION.AUDIT.ADD.SECTION_CHILD_ALREADY_SELECTED', 6);
            return
        }

        //verify that form is valid
        const form = this.$scope.auditRequirementsForm;
        // verify fields
        if(form.$invalid) {
            for (const item of form.$$controls) {
                if (item.$invalid) {
                    item.$setTouched();
                }
            }
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
            return;
        }

        this.verifyAuditExistsForRequirement(this.requirementId, this.siteLocation, this.fiscalYear).then(auditAlreadyExists => {
            if(!auditAlreadyExists) {
                const {requirementAuditDate, requirementEvidenceDate, evidenceOwner} = this;
                this.$ngRedux.dispatch({
                    type: GRID_FETCH,
                    id: IDS.accAudit,
                    path: IDS.addAuditRequirementsGrid,
                    items: [
                        {...requirement,
                            evidence_due_date:  formatDate(requirementEvidenceDate, DATE_FORMAT.OUTPUT),
                            audit_due_date:     formatDate(requirementAuditDate, DATE_FORMAT.OUTPUT),
                            evidence_owner_name:evidenceOwner.name,
                            evidence_owner:     evidenceOwner.subject_uuid,
                        },
                        ...this.assignedRequirements,
                    ]
                })
            }
        })
    }

    async onAutocompleteKeywordQuery (keyword) {
        return await this.fetchEmployeesAndManagers(
            keyword,
            this.siteLocation,
            `${this.identifier}.${IDS.assigneeCandidates}`,
        );
    }

    onButtonDetachRequirement = ({item}) => {
        this.$ngRedux.dispatch({
            type: GRID_FETCH,
            id: IDS.accAudit,
            path: IDS.addAuditRequirementsGrid,
            items: [...this.assignedRequirements.filter(requirement => requirement.id !== item.id)]
        })
    }

    findChildSectionById(id, requirements) {
        return requirements.reduce((result, item) => {
            if(result)
                return result;
            if(item.id === id)
                return item
            else if (item.children.length)
                return this.findChildSectionById(id, item.children)
        }, null);
    }

    async onLocationChange (evt, loc) {
        const subjectType = get(loc,'in_subject_basic_type_code');

        let siteLocation;
        switch(subjectType){
            case 'hof':
                if(this.paramsHof && loc.in_subject_uuid !== this.paramsHof)
                    return;
                // get head office fiscal year start
                const data = await this.AccountService.fetchHeadOffice(loc.in_subject_uuid)
                this.$ngRedux.dispatch({
                    type: TYPES.FETCH_HEAD_OFFICE_DETAILS,
                    id: IDS.addAudit,
                    data,
                });
                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        headOffice: loc.in_subject_uuid,
                        siteLocation: null,
                        // year: this.fiscalYear,
                    }
                });
            break;

            case 'slo':
                if(this.paramsSlo && loc.in_subject_uuid !== this.paramsSlo)
                    return;
                if(this.paramsSlo && loc.in_subject_uuid === this.paramsSlo) {
                    this.clearParams()
                }
                siteLocation = loc.in_subject_uuid;
                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        siteLocation: siteLocation,
                        year: this.fiscalYear,
                    }
                });
                this.resetAssignees();
                // this.fetchSiteLocationDetails( siteLocation );
                this.fetchSiteLocationContacts( siteLocation );
                await this.initSectionsInputSelects(siteLocation);
            break;
        }
    };

    clearParams() {
        this.paramsHof = null;
        this.paramsSlo = null;
        this.paramsYear = null;
    }

    async onLocationNotFound(event, location) {
        if(this.isSingleSiteUser()) {
            const siteLocation = this.user.parents[0].uuid;
            this.fetchSiteLocationContacts(siteLocation);
            await this.initSectionsInputSelects(siteLocation);
            this.$ngRedux.dispatch({
                type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                accDashboardLocationYear: {
                    siteLocation,
                }
            });
        }
    }

    onYearChange({item}) {
        this.$stateParams.year = item.value;
        if(this.fiscalYearStart !== undefined) {
            let maxYear = item.value;
            if(this.fiscalYearStart <= moment().month()) {
                maxYear++;
            }
            this.$ngRedux.dispatch({
                type: TYPES.SELECT_NEW_AUDIT_FISCAL_YEAR,
                maxDueDate: moment(`${maxYear}-01-01`).add(this.fiscalYearStart, 'months').subtract(1,'days').toDate()
            })
        }
    }

    onForwardSwitchChange() {
        if(this.isRequestForwarded === false) {
            this.$ngRedux.dispatch({
                type: TYPES.RESET_EVIDENCE_PROVIDER
            });
        }
    }

    onAddAuditorButton(){
        if(this.auditors.length >= this.MAX_AUDITORS){
            this.Notifier.error('COMMON.CLIENT_RESPONSE.UNABLE_TO_ADD_MORE_ITEMS');
            return;
        }
        if(this.auditors.some(item => item.sub_uuid === this.selectedAuditor.sub_uuid)) {
            this.Notifier.error('COMMON.CLIENT_RESPONSE.ITEM_PRESENT_ALREADY');
            return;
        }

        if(this.selectedAuditor) {
            this.addAuditor({
                sub_uuid:       this.selectedAuditor.sub_uuid,
                first_name:     this.selectedAuditor.first_name,
                last_name:      this.selectedAuditor.last_name,
                email:          this.selectedAuditor.email,
                assignee:    `${this.selectedAuditor.first_name} ${this.selectedAuditor.last_name}`,
                username:       this.selectedAuditor.username,
                type:           this.selectedAuditor.type,
            });

        }
    }

    onRemoveQualityManager(item) {
        this.$ngRedux.dispatch({
            type: TYPES.REMOVE_AUDIT_ASSIGNEE,
            id: IDS.addAudit,
            path: 'details.auditors',
            item
        });
    }

    async onEvidenceOwnerAutocompleteKeywordQuery (keyword) {
        return await this.fetchEmployeesAndManagers(
            keyword,
            this.siteLocation,
            `${this.identifier}.${IDS.evidenceOwnerCandidates}`,
        );
    }

    getFilter(keyword) {
        return item => {
            return `${item.first_name} ${item.last_name} ${item.username}`.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
        }
    }

    updateAutocompleteLabel() {
        const key = this.isQManagersSwitchOn ? 'QUALITY_MANAGERS' : 'EMPLOYEES';
        const addAuditor = this.$filter('translate')('ACCREDITATION.AUDIT.DETAILS.ADD_REVIEWER');
        const searchFrom = this.$filter('translate')(`ACCREDITATION.AUDIT.DETAILS.SEARCH_FROM_${key}`);
        this.autocompleteLabel = `${addAuditor} (${searchFrom})`;
    }

    onSubmit() {
        if(this.assignedRequirements.length === 0) {
            this.Notifier.error('ACCREDITATION.AUDIT.ADD.NO_REQUIREMENT_SELECTED');
            return;
        }
        if(this.auditors.length === 0) {
            this.Notifier.error('ACCREDITATION.AUDIT.DETAILS.NO_AUDITOR_SELECTED');
            return;
        }
        if(this.selectSiteLocationForm.$valid) {
            this.selectSiteLocationForm.$setPristine();
            this.selectSiteLocationForm.$setUntouched();
            const ctrl = this;
            this.scheduleRequirementAudits(
                this.assignedRequirements.map(item => (pick(item, ['id', 'audit_due_date', 'evidence_due_date','evidence_owner']))),
                this.siteLocation,
                this.fiscalYear,
                this.auditors.map(item => item.sub_uuid)
            ).then(() => {
                ctrl.fetchFrameworkRequirementsTreeProgress(ctrl.schemeCode, ctrl.siteLocation, ctrl.fiscalYear).then(() => {
                    ctrl.selectRequirementById(ctrl.requirementId);
                });
            });
        }
        else
            this.Notifier.error('Please fill all required fields in the form!');
    }

    $onDestroy() {
        this.unsubscribe();
        this.unsubscribeLocationChange();
        this.unsubscribeLocationNotFound();
        // this.unsubscribeSelectCascadeLoaded();
    }
}

AuditAddController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$location',
    '$scope',
    '$rootScope',
    '$filter',
    'Notifier',
    'DocumentManager',
    'AuthService',
    'AccountService',
    'EmployeeService',
    '$timeout']

export const accAuditAdd = {
    controller: AuditAddController,
    template: require('./add.html')
}
